import React, { Component, Fragment } from "react";

import CreateFolderForm from "../../containers/CreateFolderForm";

class CreateEditorFolderModal extends Component {
  constructor(props) {
    super(props);

    this.cancel = this.cancel.bind(this);
  }

  cancel() {
    this.props.handleCloseModal();
  }

  render() {
    return (
      <Fragment>
        <div className="modal__header">
          <span>{this.props.t("modals:createNewFolder")}</span>
        </div>

        <div className="modal__body">
          <div className="modal__close" onClick={this.props.handleCloseModal}>
            <svg className="bars-icon" viewBox="0 0 24 24">
              <path d="M1,1 L22,22 M1,22 L22,1" stroke="#000" strokeWidth="1" />
            </svg>
          </div>
          <CreateFolderForm handleCancel={this.cancel} t={this.props.t}/>
        </div>
      </Fragment>
    );
  }
}

export default CreateEditorFolderModal;



// WEBPACK FOOTER //
// ./src/components/modals/CreateEditorFolderModal.js